<div class="grid animated fadeIn">
  <div class="grid__unit s-4-4 m-12-12 l-8-12 xxl-span-width"
    [ngClass]="{ 'xxl-push-left' : currentRoute > Route.COMPANY_DATA }">
    <div class="tile tile--alert">
      <div>
        <i class="icon icon--alert icon--nsRed"></i>
      </div>
      <div
        [ngClass]="{ 'notificationBar__text--error': message.type === MessageType.ERROR, 'notificationBar__text--info': message.type === MessageType.INFO }"
        [innerHTML]="message.body | translate">
      </div>
      <a class="closeButton">
        <span (click)="close.emit(message)"
          class="icon">
        </span>
      </a>
    </div>
  </div>
</div>
